// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__container___j7Hm7 {
  max-width: 1140px !important;
  margin-top: 20px;
  margin-bottom: 15px;
  border-radius: 3px;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(19, 39, 48, 0.12);
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
}
.styles__container___j7Hm7 section {
  margin-bottom: 45px;
}
.styles__flexWrap___IlDkS {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.styles__flexWrapFourColumns___jtXQf {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.styles__flexIt___uFDam {
  display: flex;
  justify-content: space-between;
}
.styles__priceOptions___y0kIZ {
  text-align: right;
}
@media (max-width: 991px) {
  .styles__priceOptions___y0kIZ {
    text-align: left;
  }
}
.styles__productsListHeader___fySEg {
  position: sticky;
  background-color: #eee;
  top: 0;
  z-index: 11;
  margin-top: 15px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}
.styles__noResults___IU7cC {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}
.styles__threeColumns___HqfHd::after {
  content: "";
  width: 30%;
}
.styles__twoColumns___dSt57::after {
  content: "";
  width: calc(50% - 15px);
}
.styles__topRankColumnsContainer___k2z3s {
  max-width: 1140px !important;
  margin-top: 20px;
  margin-bottom: 15px;
  border-radius: 3px;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(19, 39, 48, 0.12);
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);
  margin-left: auto;
  margin-right: auto;
  border-radius: 4px;
  padding: 2em 2em 0 2em;
}
.styles__topRankColumnsContainer___k2z3s section {
  margin-bottom: 45px;
}
.styles__topRankColumnsContainer___k2z3s ul {
  padding: 0 !important;
  margin: 0 !important;
}
.styles__topRankColumnsContainer___k2z3s ul li {
  margin: 0 !important;
  margin-bottom: 2em !important;
  box-shadow: 0 0 3px rgba(19, 39, 48, 0.25);
}
.styles__topRankColumns___bdEFG::after {
  content: "";
  width: calc(33% - 15px);
}
.styles__fourColumns___pJrbw::after {
  content: "";
  width: calc(25% - 22.5px);
}
.styles__topRankColumns___bdEFG,
.styles__twoColumns___dSt57,
.styles__fourColumns___pJrbw {
  display: flex;
  flex-wrap: wrap;
  gap: 0 30px;
  justify-content: flex-start;
  padding-top: 20px;
}
.styles__topRankColumns___bdEFG > li,
.styles__twoColumns___dSt57 > li,
.styles__fourColumns___pJrbw > li {
  padding: 0 !important;
  margin: 0 0 30px 0 !important;
}
.styles__topRankColumns___bdEFG > .staggered-single,
.styles__twoColumns___dSt57 > .staggered-single,
.styles__fourColumns___pJrbw > .staggered-single {
  flex: 0 0 calc((100% - 90px) / 4);
}
@media (max-width: 991px) {
  .styles__topRankColumns___bdEFG > .staggered-single,
  .styles__twoColumns___dSt57 > .staggered-single,
  .styles__fourColumns___pJrbw > .staggered-single {
    flex: 1 1 100%;
  }
}
.styles__topRankColumns___bdEFG > .staggered-top-rank,
.styles__twoColumns___dSt57 > .staggered-top-rank,
.styles__fourColumns___pJrbw > .staggered-top-rank {
  flex: 0 0 calc((100% - 60px) / 3);
}
@media (max-width: 991px) {
  .styles__topRankColumns___bdEFG > .staggered-top-rank,
  .styles__twoColumns___dSt57 > .staggered-top-rank,
  .styles__fourColumns___pJrbw > .staggered-top-rank {
    flex: 1 1 100%;
  }
}
.styles__topRankColumns___bdEFG > .staggered-pair,
.styles__twoColumns___dSt57 > .staggered-pair,
.styles__fourColumns___pJrbw > .staggered-pair {
  flex: 1 1 calc(50% - 40px);
}
.styles__topRankColumns___bdEFG .styles__placeholder___Gv6VW,
.styles__twoColumns___dSt57 .styles__placeholder___Gv6VW,
.styles__fourColumns___pJrbw .styles__placeholder___Gv6VW {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.styles__loadMore___TfuYD {
  display: flex;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/shared/layout.less","webpack://./src/components/components/Search/SearchResults/ProductsList/styles.less"],"names":[],"mappings":"AAEA;EACE,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,8CAAA;EACA,kDAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;ACDF;ADTA;EAYI,mBAAA;ACAJ;AAXA;EACE,aAAA;EACA,8BAAA;EACA,eAAA;AAaF;AAVA;EACE,aAAA;EACA,2BAAA;EACA,eAAA;AAYF;AATA;EACE,aAAA;EACA,8BAAA;AAWF;AARA;EACE,iBAAA;AAUF;AATE;EAAA;IACE,gBAAA;EAYF;AACF;AATA;EACE,gBAAA;EACA,sBAAA;EACA,MAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAWF;AARA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAUF;AAPA;EACE,WAAA;EACA,UAAA;AASF;AANA;EACE,WAAA;EAEA,uBAAA;AAOF;AAJA;EDrDE,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,8CAAA;EACA,kDAAA;EAEA,iBAAA;EACA,kBAAA;EC8CA,kBAAA;EACA,sBAAA;AAcF;AAjBA;ED1CI,mBAAA;AC8DJ;AApBA;EAMI,qBAAA;EACA,oBAAA;AAiBJ;AAxBA;EAUM,oBAAA;EACA,6BAAA;EACA,0CAAA;AAiBN;AAZA;EACE,WAAA;EAEA,uBAAA;AAaF;AAVA;EACE,WAAA;EAEA,yBAAA;AAWF;AARA;;;EAGE,aAAA;EACA,eAAA;EACA,WAAA;EACA,2BAAA;EACA,iBAAA;AAUF;AAjBA;;;EAUI,qBAAA;EACA,6BAAA;AAYJ;AAvBA;;;EAeI,iCAAA;AAaJ;AAXI;EAAA;;;IACE,cAAA;EAgBJ;AACF;AAnCA;;;EAuBI,iCAAA;AAiBJ;AAfI;EAAA;;;IACE,cAAA;EAoBJ;AACF;AA/CA;;;EAgCI,0BAAA;AAoBJ;AApDA;;;EAoCI,sBAAA;EACA,2BAAA;EACA,4BAAA;AAqBJ;AAjBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAmBF","sourcesContent":["@import './variables.less';\n\n.container {\n  max-width: 1140px !important;\n  margin-top: 20px;\n  margin-bottom: 15px;\n  border-radius: 3px;\n  background-color: #fff;\n  box-shadow: @eon-box-shadow;\n  transition: @eon-transition-default;\n  border-radius: 4px;\n  margin-left: auto;\n  margin-right: auto;\n  section {\n    margin-bottom: 45px;\n  }\n}\n","@import '../../../../../shared/layout.less';\n@import '../../../../../shared/variables.less';\n\n.flexWrap {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.flexWrapFourColumns {\n  display: flex;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n}\n\n.flexIt {\n  display: flex;\n  justify-content: space-between;\n}\n\n.priceOptions {\n  text-align: right;\n  @media (max-width: @screen-sm-max) {\n    text-align: left;\n  }\n}\n\n.productsListHeader {\n  position: sticky;\n  background-color: #eee;\n  top: 0;\n  z-index: 11;\n  margin-top: 15px;\n  margin-bottom: 15px;\n  display: flex;\n  align-items: center;\n}\n\n.noResults {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 50px;\n}\n\n.threeColumns::after {\n  content: \"\";\n  width: 30%;\n}\n\n.twoColumns::after {\n  content: \"\";\n  // width: 50%;\n  width: calc(50% - 15px);\n}\n\n.topRankColumnsContainer {\n  .container();\n  border-radius: 4px;\n  padding: 2em 2em 0 2em;\n\n  ul {\n    padding: 0 !important;\n    margin: 0 !important;\n\n    li {\n      margin: 0 !important;\n      margin-bottom: 2em !important;\n      box-shadow: 0 0 3px rgba(19, 39, 48, 0.25);\n    }\n  }\n}\n\n.topRankColumns::after {\n  content: \"\";\n  // width: 25%;\n  width: calc(33% - 15px);\n}\n\n.fourColumns::after {\n  content: \"\";\n  // width: 25%;\n  width: calc(25% - 22.5px);\n}\n\n.topRankColumns,\n.twoColumns,\n.fourColumns {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0 30px;\n  justify-content: flex-start;\n  padding-top: 20px;\n\n  > li {\n    padding: 0 !important;\n    margin: 0 0 30px 0 !important;\n  }\n\n  > :global(.staggered-single) {\n    flex: 0 0 calc((100% - 90px) / 4);\n\n    @media (max-width: @screen-sm-max) {\n      flex: 1 1 100%;\n    }\n  }\n\n  > :global(.staggered-top-rank) {\n    flex: 0 0 calc((100% - 60px) / 3);\n\n    @media (max-width: @screen-sm-max) {\n      flex: 1 1 100%;\n    }\n\n  }\n\n  > :global(.staggered-pair) {\n    flex: 1 1 calc(50% - 40px);\n  }\n\n  .placeholder {\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n  }\n}\n\n.loadMore {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles__container___j7Hm7`,
	"flexWrap": `styles__flexWrap___IlDkS`,
	"flexWrapFourColumns": `styles__flexWrapFourColumns___jtXQf`,
	"flexIt": `styles__flexIt___uFDam`,
	"priceOptions": `styles__priceOptions___y0kIZ`,
	"productsListHeader": `styles__productsListHeader___fySEg`,
	"noResults": `styles__noResults___IU7cC`,
	"threeColumns": `styles__threeColumns___HqfHd`,
	"twoColumns": `styles__twoColumns___dSt57`,
	"topRankColumnsContainer": `styles__topRankColumnsContainer___k2z3s`,
	"topRankColumns": `styles__topRankColumns___bdEFG`,
	"fourColumns": `styles__fourColumns___pJrbw`,
	"placeholder": `styles__placeholder___Gv6VW`,
	"loadMore": `styles__loadMore___TfuYD`
};
export default ___CSS_LOADER_EXPORT___;
